import { render, staticRenderFns } from "./arbo.vue?vue&type=template&id=64f4ba64"
import script from "./arbo.js?vue&type=script&lang=js&external"
export * from "./arbo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports